import React,{useEffect,useState, useRef } from 'react';
import Axios from '../../lib/axios/axiosInstance';
import { useParams , useSearchParams,useNavigate } from "react-router-dom";
import { Container, Row, Col, Tab, Form } from "react-bootstrap";
import { Link } from "react-router-dom";
import * as AuthVerify from '../../lib/common';
import { Space, Table } from 'antd';
import Loader from '../Common/loader';
import CustomTable from './CustomTable';
import "./Budget.styles.css";

const Budget = () => {
  const navigate = useNavigate();
  const [userDetails, setUserDetails] = useState(false);
  const [budgets, setBudgets] = useState(false);

  const [editPermission, setEditPermission] = useState(false);
  const [deletePermission, setDeletePermission] = useState(false);
  const [viewPermission, setViewPermission] = useState(false);
  const [addNewPermission, setAddNewPermission] = useState(false);

  const budgetColumns = [
    {
        title: 'Description',
        key: 'budgetdesc',
        dataIndex: 'budgetdesc',
    },
    {
      title: 'Type',
      dataIndex: 'budgettype',
      key: 'budgettype',
    },
    {
      title: 'limit Scheme',
      dataIndex: 'limitscheme',
      key: 'limitscheme',
    },
    {
      title: 'Start Date',
      dataIndex: 'effdate',
      render: (_, record) => (
        <>
          {record.effdate.split('T')[0]}
        </>
      )
    },
    {
      title: 'End Date',
      dataIndex: 'enddate',
      render: (_, record) => (
        <>
          {record.enddate.split('T')[0]}
        </>
      )
    },
    {
      title: '',
      key: 'action',
      render: (_, record) => (
        <>
        {viewPermission && !editPermission && <Link to={`/budget-details?budgetnum=${record.budgetnum}`}>View</Link> } {" "}
        {editPermission && <Link to={`/budget-details?budgetnum=${record.budgetnum}`}>Edit</Link> }
        </>
      ),
    },
  ];


  useEffect(async () => {
    const user=AuthVerify.getUser();
    if(user){
      const permission =AuthVerify.getPermissions("Budget");
      setViewPermission(permission?.view);
      setEditPermission(permission?.edit);
      setDeletePermission(permission?.delete);
      setAddNewPermission(permission?.addnew);

      setUserDetails(user);
      //Get Budget List
      //api/corporate/budget/:arnum
      const arnum = user.arnum;//'ARM-22000075'//
      await Axios.get(`/corporate/budget/${arnum}`)
      .then(async (data) => {
        if(data.data?.data?.budgets){
          setBudgets(data.data?.data?.budgets);
        }
        else{
          setBudgets([])
        }
      });
    }
  }, [])

  return (<>
    <div className="col-main">
      <div className="my-account">
        <div className="page-title">
          <h2 style={{ paddingTop: "12px" }}>Budget</h2>
          {/* <p>Loremn osum doky sit conseete,tut ugiscirq elit. Maecenas quis ex elei'end enim eget. eleifeod gwus. Oonec quis condenentum fin bus
                  </p> */}
        </div>
            <div className="main">
                <div className="col-main">
                    <div className="shopping-cart-inner">
                        <div className="page-content">
                            <div className="page-content checkout-page">
                  <Col sm={12} style={{ padding: "5px 0px 10px 0px" }}>
                    {/* <Link to="#" style={{ float: "left", textDecoration: "none", fontWeight: "bold" }}>Import CSV</Link> */}
                    {addNewPermission && <>
                      <button style={{ float: "right", textDecoration: "none", marginLeft: "20px", fontWeight: "bold", background: "none", color: "#1890ff" }} onClick={()=>navigate('/budget-details')}>+ Add New</button>
                    </>}
                  </Col>
                                    <div className="box-border" style={{margin:"auto",width:"100%",padding:"0"}}>
                                      <CustomTable/>
                                    </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div >
      </div>
    </div>
    </>
  );
};

export default Budget;
